import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import {
  getMatchedSkillsApi,
  addToMatchesApi,
  removeFromMatchesApi,
  getMyMatches,
  getMatchesCountAPI,
  getMatchesPaginationAPI,
  addSingleMatchesApi,
  addBatchMatchesApi,
} from "../../API/API";
import { alertNotification } from "../../components/TopNotification/alertNotification";

function* SkillMatches(action) {
  try {
    const response = yield call(() =>
      getMatchedSkillsApi(action.payload.gigid)
    ); // API Backend
    yield put({
      type: types.GET_SKILL_MACTHES_SUCCESS,
      payload: response.data,
    });
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_SKILL_MACTHES_FAILURE, error });
  }
}

function* AddskillMatches(action) {
  try {
    const response = yield call(() => addToMatchesApi(action.payload)); // API Backend
    yield put({ type: types.ADD_TO_MATCHES_SUCCESS, payload: response.data });
    alertNotification(
      "success",
      "Candidate successfully matched to your job"
    );
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.ADD_TO_MATCHES_FAILURE, error });
  }
}

function* RemoveSkillMatches(action) {
  try {
    const response = yield call(() => removeFromMatchesApi(action.payload)); // API Backend
    yield put({
      type: types.REMOVE_FROM_MATCHES_SUCCESS,
      payload: response.data,
    });
     alertNotification(
      "success",
      "Matched candidate successfully removed from your job"
    );
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.REMOVE_FROM_MATCHES_FAILURE, error });
  }
}

function* findMyMatches(action) {
  try {
    const response = yield call(() => getMyMatches(action.payload)); // API Backend
    yield put({ type: types.FIND_MATCH_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FIND_MATCH_FAILURE, error });
  }
}

function* findMatchesCount(action) {
  try {
    const response = yield call(() => getMatchesCountAPI(action.payload)); // API Backend
    yield put({
      type: types.GET_MATCHES_COUNT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_MATCHES_COUNT_FAILURE, error });
  }
}

function* findMoreMatches(action) {
  try {
    const response = yield call(() => getMatchesPaginationAPI(action.payload)); // API Backend
    yield put({
      type: types.GET_MORE_MATCHES_SUCCESS,
      payload: response.data,
      data: action.payload.label,
    });
  } catch (error) {
    yield put({ type: types.GET_MORE_MATCHES_FAILURE, error });
  }
}

function* AddSingleMatches(action) {
  try {
    const response = yield call(() => addSingleMatchesApi(action.payload)); // API Backend
    yield put({
      type: types.ADD_SINGLE_MATCHES_SUCCESS,
      payload: response.data,
    });
    alertNotification("success", "Candidates added to match successfully");
  } catch (error) {
    alertNotification("error", "Something Went Wrong");
    yield put({ type: types.ADD_SINGLE_MATCHES_FAILURE, error });
  }
}
function* AddBatchMatches(action) {
  try {
    const response = yield call(() => addBatchMatchesApi(action.payload));
    
    if (response?.status == 200) {
      if (action.payload?.callBack) {
      yield call(action.payload.callBack);
    }
      yield put({
        type: types.ADD_BATCH_MATCHES_SUCCESS,
        payload: response.data,
      });
      alertNotification(
        "success",
        response?.data?.message || "Candidates added to match successfully"
      );
    }else{
      throw response
    }
  } catch (error) {
    console.log(error,'error')
    yield put({ type: types.ADD_BATCH_MATCHES_FAILURE, payload:error });
    alertNotification("error",error?.data?.message|| "Something Went Wrong");
  }
}

export function* watchGetSkillMatchesSaga() {
  yield takeEvery(types.GET_SKILL_MACTHES_REQUESTED, SkillMatches);
}

export function* watchAddtoMatchesSaga() {
  yield takeEvery(types.ADD_TO_MATCHES_REQUESTED, AddskillMatches);
}

export function* watchRemoveSkillMatches() {
  yield takeEvery(types.REMOVE_FROM_MATCHES_REQUESTED, RemoveSkillMatches);
}

export function* watchFindMyMatches() {
  yield takeLatest(types.FIND_MATCH_REQUESTED, findMyMatches);
}

export function* watchFindMyMatchesCount() {
  yield takeLatest(types.GET_MATCHES_COUNT, findMatchesCount);
}

export function* watchFindMyMatchesPaginationSaga() {
  yield takeLatest(types.GET_MORE_MATCHES_INIT, findMoreMatches);
}

export function* watchAddSingleMatchesSaga() {
  yield takeEvery(types.ADD_SINGLE_MATCHES_REQUESTED, AddSingleMatches);
}
export function* watchAddBatchMatchesSaga() {
  yield takeEvery(types.ADD_BATCH_MATCHES_REQUESTED, AddBatchMatches);
}
